if (!window.customElements.get('client-directory')) {
  class ClientDirectory extends HTMLElement {
    constructor() {
      super();
      this.main = this.querySelector('[data-client-directory-main]');
      this.toggles = this.querySelectorAll('[data-client-directory-toggle]');
      this.clients = this.querySelectorAll('[data-client-directory-client]');
      this.backButtons = this.querySelectorAll('[data-client-directory-back]');
      this.showAllButtons = this.querySelectorAll('[data-client-directory-show-all]');
      this.dashboardBackButton = document.querySelector('[data-account-dashboard-mobile-back]');
      this.allOtherSections = document.querySelectorAll('[data-account-dashboard-container] .shopify-section:not(.shopify-section--client-directory)');
    }

    connectedCallback() {
      if (!window.SwymCallbacks) { window.SwymCallbacks = [] }

      window.SwymCallbacks.push(this.onSwymLoadCallback.bind(this));

      this.toggles.forEach((toggle) => toggle.addEventListener('click', () => this.updateSelectedClient(toggle.getAttribute('data-id'))));
      this.backButtons.forEach((button) => button.addEventListener('click', () => this.goBack()));
      this.showAllButtons.forEach((button) => button.addEventListener('click', () => this.showAllToggle(button)));

      if (window.location.href.indexOf('client') >= 0) {
        const urlParams = new URLSearchParams(window.location.search);
        const clientParam = urlParams.get('client');
        const activeToggle = [...this.toggles].find(client => client.getAttribute('data-client-directory-email') === clientParam);

        if (activeToggle === undefined) { return }
        this.updateSelectedClient(activeToggle.getAttribute('data-id'))
      }
    }

    /**
     * Updated selected client and hide main step
     * @param {String} id - The address id for the client
     */
    updateSelectedClient(id) {
      this.clients.forEach((client) => client.classList.toggle('hidden', client.getAttribute('data-id') !== id));
      this.main.classList.add('hidden');
      this.dashboardBackButton.classList.add('hidden');
      this.allOtherSections.forEach((section) => section.classList.add('hide'));
    }

    /**
     * Go back to the main step
     */
    goBack() {
      this.clients.forEach((client) => client.classList.add('hidden'));
      this.main.classList.remove('hidden');
      this.dashboardBackButton.classList.remove('hidden');
      this.allOtherSections.forEach((section) => section.classList.remove('hide'));
    }

    /**
     * Show all steps within the parent box
     * @param {Element} button - The button that was clicked
     */
    showAllToggle(button) {
      const parentWrapper = button.closest('[data-client-directory-show-all-parent]');
      const items = parentWrapper.querySelectorAll(button.getAttribute('data-target-attribute'));

      parentWrapper.classList.toggle('active');

      items.forEach((item, index) => {
        if (parentWrapper.classList.contains('active')) {
          item.classList.remove('hidden');
        } else {
          item.classList.toggle('hidden', index > 2);
        }
      });
    }

    // updated swymcallback start.

    onSwymLoadCallback(swat) {
      if (swat) {
        swat.fetchLists({
          callbackFn: this.buildLists.bind(this),
        })
      } else {
        window.location.reload();
      }
    }

    buildLists(lists) {
      const savedProtocols = document.querySelectorAll("saved-protocols");
      savedProtocols.forEach((protocol, index) => {
        protocol.buildLists(lists);
      });
    }

    // updated swymcallback end.

  }

  window.customElements.define('client-directory', ClientDirectory);
}

if (!window.customElements.get('delete-address-form')) {
  class DeleteAddressForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
    }

    connectedCallback() {
      this.form.addEventListener('submit', (event) => this.formSubmission(event));
    }

    /**
     * Stop form redirect and handle address deletion submission
     * @param {Event} event - Form submission event
     */
    async formSubmission(event) {
      event.preventDefault();

      try {
        const url = this.form.getAttribute('action');
        const formData = new FormData(this.form);
        const response = await fetch(url, {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }

        window.location.reload();

      } catch (error) {
        console.error(error.message);
      }
    }
  }

  window.customElements.define('delete-address-form', DeleteAddressForm);
}